const extend = require('extend')

export default {
  namespaced: true,
  state: {
    search: '',
    pageInfo: {
      currentPage: 1
    },
    selectedCategories: [],
    categories: [],
    results: [],
    limit: 50,
    count: 0,
    offset: 0,
    siteId: null,
    section: 'staff',
    orderBy: 'lastName asc'
  },
  mutations: {
    UPDATE_PAGEINFO (state, pageInfo) {
      state.pageInfo = pageInfo
    },
    UPDATE_COUNT (state, count) {
      if (state.count !== count) {
        // only change the offset if the number of results has changed
        state.count = count
      }
    },
    UPDATE_OFFSET (state, number) {
      state.offset = state.limit * (number - 1)
    },
    UPDATE_ORDER (state, string) {
      state.pageInfo = {
        ...state.pageInfo,
        currentPage: 1
      }
      state.offset = 0
      state.orderBy = string
    },
    UPDATE_RESULTS (state, results) {
      state.results = results
    },
    UPDATE_SEARCH (state, search) {
      state.pageInfo = {
        ...state.pageInfo,
        currentPage: 1
      }
      state.offset = 0
      state.search = search
    },
    UPDATE_CATEGORIES (state, categories) {
      state.categories = categories
    },
    UPDATE_SELECTED_CATEGORIES (state, selectedCategories) {
      state.pageInfo = {
        ...state.pageInfo,
        currentPage: 1
      }
      state.offset = 0

      let updated = false
      state.selectedCategories.forEach(cat => {
        if (cat.categoryId === selectedCategories.categoryId) {
          cat.categories = selectedCategories.categories
          updated = true
        }
      })
      if (updated === false) {
        state.selectedCategories.push(selectedCategories)
      }
    },
    UPDATE_LIMIT (state, number) {
      state.limit = number
    }
  },
  getters: {
    relatedTo: state => {
      const temp = []
      state.selectedCategories.forEach(obj => {
        if (obj.categories.length) {
          obj.categories.forEach(item => temp.push(item))
        }
      })
      return temp
    },
    variables: (state, getters) => {
      const variables = {}

      if (getters.relatedTo.length) {
        const related = { relatedTo: getters.relatedTo }
        extend(variables, related)
      }

      const search = { search: state.search, orderBy: 'score' }
      extend(variables, search)

      const offset = { offset: state.offset }
      extend(variables, offset)

      const orderBy = { orderBy: state.orderBy }
      extend(variables, orderBy)

      const section = { section: state.section }
      extend(variables, section)

      const limit = { limit: state.limit }
      extend(variables, limit)
      return variables
    }
  }
}
